export default {
  mode: {
    light: "Chiaro",
    dark: "Scuro"
  },
  
  guide: {
    title: "Guida al Tema"
  },
  
  colors: {
    title: "Colori",
    primary500: "Primario 500",
    primary600: "Primario 600", 
    primary700: "Primario 700",
    secondary500: "Secondario 500",
    success: "Successo",
    warning: "Avvertimento",
    error: "Errore",
    background: "Sfondo",
    surface: "Superficie",
    card: "Scheda"
  },
  
  typography: {
    title: "Tipografia",
    h1: "Titolo 1",
    h1Font: "Testo 4xl Serif",
    h2: "Titolo 2", 
    h2Font: "Testo 3xl Serif",
    h3: "Titolo 3",
    h3Font: "Testo 2xl Serif",
    body: "Testo del corpo",
    bodyFont: "Testo base",
    small: "Testo piccolo",
    smallFont: "Testo sm"
  },
  
  components: {
    title: "Componenti",
    
    buttons: {
      title: "Pulsanti",
      default: "Predefinito",
      outline: "Contorno",
      secondary: "Secondario", 
      ghost: "Fantasma",
      danger: "Pericolo",
      success: "Successo",
      disabled: "Disabilitato",
      loading: "Caricamento"
    },
    
    form: {
      title: "Elementi del Modulo",
      input: "Campo di Input",
      select: "Campo di Selezione",
      switch: "Interruttore"
    },
    
    badges: {
      title: "Badge",
      default: "Predefinito",
      secondary: "Secondario",
      success: "Successo",
      warning: "Avvertimento",
      error: "Errore",
      mint: "Menta",
      rose: "Rosa",
      outline: "Contorno"
    },
    
    alerts: {
      title: "Avvisi",
      info: {
        title: "Informazione",
        description: "Questo è un avviso informativo."
      },
      success: {
        title: "Successo",
        description: "Questo è un avviso di successo."
      },
      warning: {
        title: "Avvertimento", 
        description: "Questo è un avviso di avvertimento."
      },
      error: {
        title: "Errore",
        description: "Questo è un avviso di errore."
      }
    }
  },
  
  code: {
    title: "Esempi di Codice",
    darkMode: {
      title: "Implementazione Modalità Scura",
      example: "className=\"bg-white dark:bg-dark-card text-gray-900 dark:text-white\""
    }
  }
} 